import * as React from "react";
import styled from "styled-components";

export const StandardContainer = styled.div`
    padding: 40px;
    padding-bottom: 64px;
`;
